import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pnc_ic_jcjc",
  "use": "icon-pnc_ic_jcjc-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pnc_ic_jcjc\"><path d=\"m10 10.1c0-1.2 1.1-2.1 2.4-2.1h19.1c1.4 0 2.4.9 2.4 2.1v9.2c0 2.9-1.2 5.6-3.2 7.6-1.8 1.8-3 4.1-3.4 6.7l-.3 1.9c-.2 1.4-1.4 2.5-2.9 2.5h-4.8c-1.4 0-2.6-1.1-2.8-2.5l-.2-1.7c-.3-2.6-1.5-5-3.3-6.9-2-2-3.1-4.8-3.1-7.6v-9.2z\" fill=\"#0fb833\" /><path d=\"m23.5 18.3h1.8c.9 0 1.4 1.2.6 1.8l-4.4 3.8c-.8.6-1.9-.1-1.6-1l.6-2.1h-1.8c-.9 0-1.4-1.2-.6-1.8l4.4-3.8c.8-.6 1.9.1 1.6 1z\" fill=\"#fff\" /><g fill=\"#0fb833\"><path d=\"m18.3 3.2v1.7c0 .6-.4 1-1 1h-3.5c-.6 0-1-.4-1-1v-1.7c0-.6.4-1 1-1h3.5c.6 0 1 .5 1 1z\" /><path d=\"m25.7 4.9v-1.7c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1v1.7c0 .6-.4 1-1 1h-3.5c-.6 0-1-.4-1-1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pnc_ic_jcjc.svg
// module id = g8/Y
// module chunks = 87